import React, { useState, useMemo } from "react";
import { useSelector } from "react-redux";

import {
  makeStyles,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  Collapse,
} from "@material-ui/core";

import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ExpandLess from "@material-ui/icons/ExpandLess";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";

import PlaidLink from "../../../components/PlaidLink";
import api from "../../../services/api";

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

const PlaidInstitutionListItem = ({ item }) => {
  const [removeDialogOpen, setRemoveDialogOpen] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handlePlaidRemoveInstituion = async () => {
    setLoading(true);
    setRemoveDialogOpen(false);
    await api.removePlaidItem(item);
    setLoading(false);
  };
  const { metadata } = item;

  const formatNumAccounts = () =>
    metadata.accounts.length === 1
      ? "1 account"
      : `${metadata.accounts.length} accounts`;

  return (
    <>
      <ListItem
        button
        onClick={() => setInfoDialogOpen(true)}
        className={classes.nested}
      >
        {`${item.metadata.institution.name} - ${formatNumAccounts()}`}
        <ListItemSecondaryAction>
          <IconButton
            onClick={() => setRemoveDialogOpen(true)}
            edge="end"
            aria-label="comments"
          >
            <ClearIcon />
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
      <Dialog
        open={removeDialogOpen}
        onClose={() => setRemoveDialogOpen(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          Are you sure you want to remove this Institution?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            You'll have to add it again to continue getting transactions from{" "}
            <b>{metadata.institution.name}</b>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRemoveDialogOpen(false)}>Cancel</Button>
          <Button onClick={handlePlaidRemoveInstituion}>OK</Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={infoDialogOpen}
        onClose={() => setInfoDialogOpen(false)}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {metadata.institution.name + " - " + formatNumAccounts()}
        </DialogTitle>
        <DialogContent>
          <List>
            {metadata.accounts.map((account, i) => (
              <ListItem key={i}>
                {account.name} ({account.mask}) - {account.subtype}
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setInfoDialogOpen(false)}>OK</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default () => {
  const [listOpen, setListOpen] = useState(false);

  const plaid_items = useSelector(
    (state) => state.firebase.profile.plaid_items
  );
  const uid = useSelector((state) => state.firebase.auth.uid);

  const numAccounts = useMemo(() =>
    plaid_items && Object.values(plaid_items).length > 0
      ? Object.values(plaid_items)
          .map((item) => item.metadata.accounts.length)
          .reduce((a, b) => a + b)
      : 0
  );
  const numInstitutions = useMemo(
    () => plaid_items && Object.keys(plaid_items).length
  );
  const isFirst = numAccounts === 0;
  const handleClick = () => setListOpen(!listOpen);
  return (
    <>
      {!isFirst && (
        <>
          <ListItem button onClick={handleClick}>
            <ListItemIcon>
              <AccountBalanceIcon />
            </ListItemIcon>
            <ListItemText primary={`${numAccounts} Accounts`} />
            {listOpen ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={listOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {Object.values(plaid_items).map((item, i) => (
                <PlaidInstitutionListItem key={i} item={item} />
              ))}
            </List>
          </Collapse>
        </>
      )}
      <PlaidLink isSixth={numInstitutions >= 5}>
        <ListItem button>
          <ListItemIcon>
            {isFirst ? <AccountBalanceIcon /> : <AddCircleOutlineIcon />}
          </ListItemIcon>
          {isFirst ? "Link your first account" : "Link another account "}
        </ListItem>
      </PlaidLink>
    </>
  );
};
